export default "__VITE_ASSET__B1RXK_Wm__"